// extracted by mini-css-extract-plugin
export default {"chips":"SettingChips_chips__Juquo","chip":"SettingChips_chip__NI5iN","chipActive":"SettingChips_chipActive__QLf2k"};